import { UnprocessedFlowChart } from '../models/UnprocessedFlowChart';
import { FlowChart, MarkerPage, Page } from '../models/FlowChart';

export class SelectionWizardService {
  private static readonly _INSTANCE_ = new SelectionWizardService();

  private constructor() { }

  static getInstance() {
    return SelectionWizardService._INSTANCE_;
  }

  async getFlowChart(): Promise<FlowChart> {
    const response = await fetch('/data/flow-chart/flow-chart.json');
    const unprocessedFlowChart = (await response.json()) as UnprocessedFlowChart;
    const pageMap = this._createPageMap(unprocessedFlowChart);
    this._resolveNextReferences(unprocessedFlowChart, pageMap);
    MarkerPage.EXIT.number = unprocessedFlowChart.sequence.length + 1;
    return new FlowChart(
      unprocessedFlowChart.sequence.map((pageId, index) => {
        const page = pageMap.get(pageId);
        if (!page) {
          throw new Error(`Page with ID "${pageId}" in "sequence" does not have a definition`);
        }
        page.number = index + 1;
        return page;
      }),
      pageMap
    );
  }

  private _createPageMap(unprocessedFlowChart: UnprocessedFlowChart) {
    const pageMap = new Map<string, Page>();
    for (const [pageId, pageDefinition] of Object.entries(unprocessedFlowChart.pageDefinitions)) {
      pageMap.set(pageId, {
        number: 1,
        label: pageDefinition.label,
        required: Boolean(pageDefinition.required),
        UUID: pageDefinition.UUID,
        level: 0,
        key: pageDefinition.key || '',
        description: pageDefinition.description,
        multiple: Boolean(pageDefinition.multiple),
        question: pageDefinition.question || pageDefinition.label,
        options: (pageDefinition.options || []).map((e) => ({
          UUID: e.UUID,
          label: e.label,
          description: e.description,
          id: e.id || e.label.toLowerCase().split(' ').join('-'),
          actions: e.actions || [],
          next: [] as Page[]
        }))
      });
    }
    return pageMap;
  }

  private _resolveNextReferences(unprocessedFlowChart: UnprocessedFlowChart, pageMap: Map<string, Page>) {
    for (const [pageId, page] of pageMap) {
      if (unprocessedFlowChart.pageDefinitions[pageId].options) {
        unprocessedFlowChart.pageDefinitions[pageId].options.forEach((option, i) => {
          if (option.next) {
            page.options[i].next = option.next.map((referencedPageId, j) => {
              const foundPage = pageMap.get(referencedPageId);
              if (!foundPage) {
                throw new Error(
                  `Page with ID "${referencedPageId}" does not exist, it's being referenced from ${pageId}->options[${i}]->next[${j}]`
                );
              }
              foundPage.level = page.level + 1;
              return foundPage;
            });
          }
        });
      }
    }
  }
}
